export const getData = async ($: JQueryStatic) => {
  const $map = $('.paragraph--type--interaktivnaya-karta')
  const settlementID = $('.field--name-field-paragraphs-settlement', $map).text()
  const coordsURL = $('.field--name-field-map-coords-file', $map).text()
  if (!coordsURL) {
    throw new Error('Не найдена ссылка на файл с координатами')
  }

  const [plotsData, plotsCoords]: [PlotsDataObject[], PlotsCoords] = await Promise.all([$.getJSON(`/api/plots/${settlementID}/data.json`), $.getJSON(coordsURL)])

  if (!plotsData || !plotsCoords) {
    throw new Error('Не удалось загрузить данные')
  }

  const finalData: FinalData = {
    plots: {},
    special: [],
  }
  for (const plotData of plotsData) {
    const plotDataClone = ({ ...plotData}) as Partial<PlotsDataObject>
    delete plotDataClone.title
    finalData.plots[plotData.title] = plotDataClone
  }

  // From SVG data - plots
  for (const plotCoords of plotsCoords.plots) {
    const id = String(plotCoords.plotID)
    if (Object.hasOwn(finalData.plots, id)) {
      finalData.plots[id].coords = plotCoords.coords
    } else {
      finalData.plots[id] = {
        coords: plotCoords.coords,
      }
    }
  }

  // From SVG data - special
  if (plotsCoords.special) {
    for (const plotCoords of plotsCoords.special) {
      finalData.special.push({coords: plotCoords.coords})
    }
  }

  finalData.entrance = plotsCoords.entrance

  return finalData
}

export type PlotsDataObject = {
  field_cena_za_sotku_export: string | undefined;
  field_cena_za_uchastok_export: string | undefined;
  field_cena_za_sotku_discount_export: string | undefined;
  field_cena_za_uchastok_discount_export: string | undefined;
  field_kad_nomer_export: string | undefined;
  field_ploschad_export: string | undefined;
  field_status_export: string | undefined;
  title: string;
  field_link_to_special_export: string | undefined;
}

export type EntranceData = {
  gpsCoords: string;
  imageCoords: [number, number];
}

type PlotsCoords = {
  entrance?: EntranceData;
  plots: [{
    plotID: number | string;
    coords: number[][];
  }];
  special?: [{
    coords: number[][];
  }];
}

export type FinalPlotData =
    Partial<PlotsDataObject>
    & { coords?: number[][] }

export type FinalData = {
  plots: {
    [key: string]: FinalPlotData;
  };
  special: Array<{
    coords: number[][];
  }>;
  entrance?: EntranceData;
}
